import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserRecord } from '../model/userRecord';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from './globalService';
import { catchError, map,shareReplay } from 'rxjs/operators';
import { of } from 'rxjs';


@Injectable({providedIn: 'root'})
export class UserService {

    private userRecords: Observable<UserRecord[]>;
    private userList: UserRecord[];
    private groupList: any;
    private headers: HttpHeaders;
    private headersnew: HttpHeaders;
    private url: string;

    constructor(private httpClient: HttpClient, private globalService: GlobalService) {
       this.headers = new HttpHeaders({'Content-Type': 'application/json','Accept': 'application/json',
            'Authorization':this.globalService.UserToken
        });
    }

    public getUserLoginInfo(): UserRecord {
        return JSON.parse(localStorage.getItem('currentUser'));
    }

    public getUserByID(id: number): string {
        if (this.userList.length > 0) {
            if (id !== null && id !== undefined) {
                return this.userList.filter(u => u.id === id)[0].display_name;
            } else {
                return this.userList.filter(u => u.id === 1)[0].display_name;
            }
        } else {
            return '';
        }
    }

    public getUserByUserName(username: string): Observable<UserRecord> {
        return this.getUserRecords().pipe(map(u => u.filter(user => user.username === username)[0]));
    }
    
    public getUserByEmail(email: string): Observable<UserRecord | null> {
        return this.getUserRecords().pipe(
            map((users: UserRecord[] | null) => {
                if (!users || !Array.isArray(users)) {
                    console.warn('Users list is null or not an array');
                    return null;
                }
                if (!email) {
                    console.warn('Email parameter is null or empty');
                    return null;
                }
                const normalizedEmail = email.toLowerCase();
                const foundUser = users.find(user =>
                    user?.email && user.email.toLowerCase() === normalizedEmail
                );
                console.log('Found user:', foundUser?.email ? true : false);
                return foundUser ?? null;
            })
        );
    }


    public getUserToken(username: string): Observable<string> {
        this.headersnew = new HttpHeaders({'Content-Type': 'application/json'});
        const login = {
            'username': username,
            'password': environment.authKey
        }

        this.url = environment.url + 'api-token-auth/';
        return this.httpClient.post(this.url, JSON.stringify(login), { headers: this.headersnew }).pipe(map((res: any) => res.token));

    }
    
    public getUserRecords(forceRefresh?: boolean): Observable<UserRecord[]> {
        this.url = environment.url + 'user/';
        this.headersnew = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        return this.httpClient.get<any>(this.url, { headers: this.headersnew })
            .pipe(
                map(res => {
                    // Case 1: API returns array directly
                    if (Array.isArray(res)) {
                        return res.filter(user => user?.email);
                    }
                    // Case 2: API returns { results: [...] }
                    if (res?.results && Array.isArray(res.results)) {
                        return res.results.filter(user => user?.email);
                    }
                    // Case 3: unexpected format
                    console.warn('Unexpected API format:', res);
                    return [];
                }),

                catchError(err => {
                    console.error('Error retrieving user records:', err);
                    return of([]);   //MUST return Observable
                })

            );
    }


    public getUserInreviewRecords(forceRefresh?: boolean): Observable<UserRecord[]> {
        const headers = new HttpHeaders({
            'Authorization': this.globalService.UserToken, // Replace 'Bearer' with your preferred authentication method
            'Content-Type': 'application/json' // Optionally, set other headers as needed
        });
    
        this.url = environment.url + 'users/inreview/';
    
        return this.httpClient.get<UserRecord[]>(this.url, { headers: headers });
    }

    public getUserCompletedRecords(forceRefresh?: boolean): Observable<UserRecord[]> {
        const headers = new HttpHeaders({
            'Authorization': this.globalService.UserToken, // Replace 'Bearer' with your preferred authentication method
            'Content-Type': 'application/json' // Optionally, set other headers as needed
        });
    
        this.url = environment.url + 'users/completed/';
    
        return this.httpClient.get<UserRecord[]>(this.url, { headers: headers });    }
    

    public loadUserList(forceRefresh?: boolean): void {
        if (!this.userList || forceRefresh) {
             this.url = environment.url + 'user/',
              this.userList = [];
              this.httpClient.get(this.url)
                .pipe(map((res: any) => res.results))
                .subscribe(result => {
                    result.forEach((u:UserRecord) => {
                        this.userList.push(new UserRecord().deserialize(u));
                    });
                });
        }
    }

    public saveUserRecord(user_record: UserRecord): Observable<UserRecord> {
        if (!user_record.id) {
            user_record.password = environment.authKey;
            this.url = environment.url + 'user/';
            return this.httpClient.post(this.url, JSON.stringify(user_record), { headers: this.headers })
                            .pipe(map((res: UserRecord) => {
                                this.getUserRecords(true); return res;
                            }));
        } else {
            this.url = environment.url + 'user/' + user_record.id + '/';
            return this.httpClient.patch(this.url, JSON.stringify(user_record), { headers: this.headers })
                            .pipe(map((res: UserRecord) => {
                                this.getUserRecords(true); return res;
                            }));
        }

    }

    public deleteUserRecord(user_record: UserRecord): Observable<UserRecord> {
        this.url = environment.url + 'user/' + user_record.id + '/';
        return this.httpClient.delete(this.url, { headers: this.headers })
            .pipe(map((res: UserRecord) => {
                this.getUserRecords(true); return res;
            }));
    }

    public getAccessGroups(forceRefresh?: boolean): any {
        if (!this.groupList || forceRefresh) {
            this.url = environment.url + 'group/';
            this.groupList = this.httpClient.get(this.url, { headers: this.headers })
                             .pipe(map((res: any) => res.results));;
            return this.groupList;
        }
        return this.groupList;
    }
}
